var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 14.6667,
    fill: "#F17909"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6665 15.8333V39.1667C17.6665 39.6271 17.2935 40 16.8331 40C16.3727 40 15.9998 39.6271 15.9998 39.1667V15.8333C15.9998 15.3729 16.3727 15 16.8331 15C17.2935 15 17.6665 15.3729 17.6665 15.8333ZM38.4998 26.6667H23.0113L26.8499 22.828C27.1749 22.503 27.1749 21.9749 26.8499 21.6499C26.5249 21.3249 25.9968 21.3249 25.6718 21.6499L20.4105 26.9112C20.0854 27.2362 20.0854 27.7643 20.4105 28.0893L25.6718 33.3507C25.8343 33.5132 26.0478 33.5944 26.2614 33.5944C26.4749 33.5944 26.6874 33.5132 26.8509 33.3507C27.1759 33.0257 27.1759 32.4975 26.8509 32.1725L23.0123 28.3331H38.5008C38.9612 28.3331 39.3341 27.9602 39.3341 27.4997C39.3341 27.0393 38.9612 26.6664 38.5008 26.6664L38.4998 26.6667Z",
    fill: "#F3F1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon4.ec4e4a2336ea0cee75b2d2879d8a9e52.svg";
export { ForwardRef as ReactComponent };